'use client';
import { DOMAINS } from '@/helpers/constants';
import { useGetCommonStore } from '@/store';
import { licenseAttributes } from './helpers';

import { ScLicense } from './styled';

export const FooterLicenseContent = () => {
  const useCommonStore = useGetCommonStore();

  const hostname = useCommonStore.use.hostname();

  return (
    <ScLicense
      {...(hostname === DOMAINS.OTHER
        ? licenseAttributes.otherDomain
        : licenseAttributes.default)}
    />
  );
};
